<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        :tableHeight="tableHeight"
        v-wechat-title="title"
        :addButton="{ permission: 'permission:create' }"
        :deleteButton="{ permission: 'permission:update' }"
        :updateButton="{ permission: 'permission:delete' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `OrganizationSection`,
    props: {

    },
    data() {
        return {
            title: `组织架构-科室`,
            // url: "/api/AcisSystem/Section",
            url: { baseURL: `/api/AcisSystem/Section`,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/Section/Get`)
                        req.then(data => {
                            resolve(_.filter(data, d => {
                                return _.some(this.hospital_ward_auth, { value: d.dic_hospital_ward_id })
                            }))
                        }).catch(e => reject(e))
                    })
                } },
            buttons: []
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`hospital_ward_auth`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `dic_hospital_ward_id`,
                label: `院区`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this[`hospital_ward_auth`],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false,
                sortable: false
            }, {
                type: `string`,
                prop: `description`,
                label: `描述`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: false
            }]
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organization/Section/Index.vue